import { Injectable, signal } from '@angular/core';

export interface UpdateInfo {
  version: string;
  releaseNotes?: string;
  releaseDate?: string;
}

@Injectable({ providedIn: 'root' })
export class AppUpdaterService {
  readonly available = signal<boolean>(false);
  readonly latestVersion = signal<string>('');
  readonly downloading = signal<boolean>(false);
  readonly progressPercent = signal<number>(0);
  readonly ready = signal<boolean>(false);
  readonly error = signal<string>('');

  private wired = false;

  init(): void {
    if (this.wired) return;
    const api: any = (window as any).electronAPI;
    if (!api?.updater) return;

    api.updater.onAvailable((info: UpdateInfo) => {
      this.available.set(true);
      this.latestVersion.set(info?.version || '');
    });
    api.updater.onNotAvailable(() => this.available.set(false));
    api.updater.onProgress((p: { percent: number }) => {
      this.downloading.set(true);
      this.progressPercent.set(Math.round(p?.percent || 0));
    });
    api.updater.onReady((info: UpdateInfo) => {
      this.downloading.set(false);
      this.ready.set(true);
      this.latestVersion.set(info?.version || this.latestVersion());
    });
    api.updater.onError((msg: string) => this.error.set(msg));

    this.wired = true;
  }

  async checkNow(): Promise<void> {
    const api: any = (window as any).electronAPI;
    await api?.updater?.check?.();
  }

  async downloadUpdate(): Promise<void> {
    const api: any = (window as any).electronAPI;
    this.downloading.set(true);
    await api?.updater?.download?.();
  }

  async installNow(): Promise<void> {
    const api: any = (window as any).electronAPI;
    await api?.updater?.installNow?.();
  }
}
